import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';
import { GatewayService } from 'src/app/gateway.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-pxa-auditoria',
  templateUrl: './pxa-auditoria.component.html',
  styleUrls: ['./pxa-auditoria.component.scss']
})
export class PxaAuditoriaComponent implements OnInit {

  regla: any;
  loading: boolean = false;

  displayedColumns: string[] = ['fecha', 'accion', 'campo_modificado', 'valor_anterior', 'valor_nuevo', 'usuario_nombre'];
  dataSource = new MatTableDataSource<any>([]);

  // Colores por accion
  accionColores: { [key: string]: string } = {
    'CREAR': '#2e7d32',
    'EDITAR': '#1565c0',
    'ELIMINAR': '#c62828'
  };

  constructor(
    private spinner: NgxSpinnerService,
    private dialogRef: MatDialogRef<PxaAuditoriaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private gateway: GatewayService
  ) {
    this.regla = data.regla;
  }

  ngOnInit() {
    this.cargarAuditoria();
  }

  cargarAuditoria() {
    this.loading = true;
    this.gateway.get('auditoriapxa', { ID_REGLA: this.regla.id }).then((res: any) => {
      this.dataSource.data = res.rows || [];
      this.loading = false;
    }).catch(err => {
      this.loading = false;
    });
  }

  getAccionColor(accion: string): string {
    return this.accionColores[accion] || '#757575';
  }

  cerrar() {
    this.dialogRef.close();
  }
}
